const r = "_alertWrapper_1viu5_1", e = "_loaderWrapper_1viu5_2", a = {
  alertWrapper: r,
  loaderWrapper: e
};
export {
  r as alertWrapper,
  a as default,
  e as loaderWrapper
};
